export default "__VITE_ASSET__T_GfmddB__"